import { render, staticRenderFns } from "./CourseSectionList.vue?vue&type=template&id=55f0aa08&scoped=true&"
import script from "./CourseSectionList.vue?vue&type=script&lang=js&"
export * from "./CourseSectionList.vue?vue&type=script&lang=js&"
import style0 from "./CourseSectionList.vue?vue&type=style&index=0&id=55f0aa08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0aa08",
  null
  
)

export default component.exports